// extracted by mini-css-extract-plugin
export default {"container":"ErrorsGraph_container__lJizm","noData":"ErrorsGraph_noData__ShW59"};